<template>
  <v-flex xs12>
    <data-source-table
      itemController="aiResult"
      itemIdentifyField="model"
      :headers="headers"
      :options.sync="options"
      :selected-items.sync="selectedItems"
      ref="dataSourceRef"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <confirm-dialog
            :is-open.sync="dialogs.addTag.isOpened"
            width="400"
            @confirm="addTag"
            confirm-button-text="save"
          >
            <template v-slot:title>
              Ai Tags.
              model: "{{ dialogs.addTag.data.item.model }}"
              object id: {{ dialogs.addTag.data.item.object_id }}
            </template>
            <template v-slot:body>
              <v-autocomplete
                item-text="name"
                label="tags"
                clearable
                dense
                chips
                small-chips
                v-model="dialogs.addTag.data.tag"
                :items="tagsList"
                :filter="nonDiacriticsSensitiveFilter"
                return-object
              />
            </template>
          </confirm-dialog>
          <confirm-dialog
            :is-open.sync="dialogs.resultData.isOpened"
            :show-confirm-button="false"
            dialog-max-width="75%"
          >
            <template v-slot:title>
              Ai Result.
              model: "{{ dialogs.resultData.data.item.model }}"
              object id: {{ dialogs.resultData.data.item.object_id }}
            </template>
            <template v-slot:body>
              <v-row>
                <v-col
                  cols="12"
                >
                  <pre>{{ dialogs.resultData.data.item.result }}</pre>
                </v-col>
              </v-row>
            </template>
          </confirm-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.bad_tags="{ item }">
        <v-btn
          text
          color="teal accent-4"
          fab
          small
          @click="openDialog('addTag', { item: item })"
        >
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <slot>
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-label
                </v-icon>
              </slot>
            </template>
            add tag
          </v-tooltip>
        </v-btn>
        <v-chip
          v-for="(tag, index) in item.bad_tags"
          :key="tag"
          close
          @click:close="deleteTag(item, index)"
          class="ma-0"
          dark
          small
        >
          {{ tag }}
        </v-chip>
      </template>

      <template v-slot:item.result="{ item }">
        <v-btn
          class="mx-2" color="primary"
          dark small
          @click="openDialog('resultData', { item: item})"
        >Show result data</v-btn>
      </template>
    </data-source-table>
  </v-flex>
</template>

<script>
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';
import DataSourceTable from '../components/DataSource/DataTable.vue';
import manageDialogsMixin from '../mixins/manageDialogsMixin';

export default {
  name: 'AiResults',
  components: {
    ConfirmDialog,
    DataSourceTable,
  },
  mixins: [
    manageDialogsMixin,
  ],
  data: () => ({
    itemClone: {},
    selectedItems: [],
    options: { filters: { } },
    modelsList: [],
    tagsList: [],

    dialogs: {
      addTag: {
        isOpened: false,
        data: {
          item: '',
          tag: null,
        },
        defaults: {
          item: '',
          tag: null,
        },
      },
      resultData: {
        isOpened: false,
        data: {
          item: '',
        },
        defaults: {
          item: '',
        },
      },
    },
  }),

  created() {
    this.$requestHelpers
      .get('api/admin/aiResult/filtersList')
      .then((response) => {
        this.modelsList = response.data.result.models;
        this.tagsList = response.data.result.tags;
      });
  },

  methods: {
    addTag() {
      if (!this.dialogs.addTag.data.tag) return;

      if (this.dialogs.addTag.data.item.bad_tags) {
        this.dialogs.addTag.data.item.bad_tags.push(this.dialogs.addTag.data.tag);
        this.dialogs.addTag.data.item.bad_tags = this.dialogs.addTag.data.item.bad_tags
          .filter((e, i, j) => i === j.indexOf(e));
      } else {
        this.dialogs.addTag.data.item.bad_tags = [this.dialogs.addTag.data.tag];
      }

      this.updateItem(
        'bad_tags', this.dialogs.addTag.data.item.bad_tags, this.dialogs.addTag.data.item,
      ).finally(() => this.closeDialog('addTag'));
    },

    deleteTag(item, index) {
      const cloneItem = { ...item };
      cloneItem.bad_tags.splice(index, 1);

      this.updateItem('bad_tags', cloneItem.bad_tags, item);
    },

    updateItem(field, value, item) {
      return this.$refs.dataSourceRef.updateItemField(field, value, item);
    },
  },

  computed: {
    headers() {
      return [
        {
          text: 'id',
          value: 'id',
          width: '120px',
        },
        {
          text: 'model',
          value: 'model',
          filter: { type: 'multipleSelect', items: this.modelsList },
        },
        {
          text: 'object_id',
          value: 'object_id',
        },
        {
          text: 'bad_tags',
          value: 'bad_tags',
          filter: { type: 'select', items: this.tagsList },
        },
        {
          text: 'result',
          value: 'result',
        },
        {
          text: 'updated_at',
          value: 'updated_at',
        },
      ];
    },
  },
};
</script>
